import { render, staticRenderFns } from "./ServiceTakerEmployeeInlineTable.vue?vue&type=template&id=6fff4cf6&"
import script from "./ServiceTakerEmployeeInlineTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTakerEmployeeInlineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports